import { ZimbraMailingReportProfilePermissions, ZimbraMailingReportProfileDelegate } from '@i2a/web-api-client';

export class ZimbraMailingDelegate {
    permissions: ZimbraMailingReportProfilePermissions;
    accesses: ZimbraMailingReportProfileDelegate;
}
